export default {
  namespaced: true,
  state: {
    isLoading: false,
    loaderType: "default",
    appLoading: false,
    maintenanceMode: false,
  },
  mutations: {
    setLoading(state, status) {
      state.isLoading = status;
    },
    setLoaderType(state, value) {
      state.loaderType = value;
    },
    setAppLoading(state, status) {
      state.appLoading = status;
    },
    setMaintenanceMode(state, status) {
      state.maintenanceMode = status;
    },
  },
  actions: {
    setLoadingStatus({ commit }, status) {
      commit("setLoading", status);
    },
  },
  getters: {
    getLoadingStatus(state) {
      return state.isLoading;
    },
    getLoaderType(state) {
      return state.loaderType;
    },
  },
};
